import {
  Fetchios,
  type FetchiosDefaultParams,
} from "@caprikorn/dynamo-utils/src/utils/fetchios";

import { LS_KEYS } from "@core/core.constants";

export const DOWNLOAD_TIMEOUT = 120000;

export const GROUP_REFERENCE = {
  current: "",
};

const getApiEcmsUrl = (): string => {
  const tenant =
    window.tenant === "kuriosity"
      ? localStorage.getItem(LS_KEYS.TENANT) || "kuriosity"
      : window.tenant;

  return tenant === "ekwateur"
    ? import.meta.env.VITE_APP_API_ROOT_EKWATEUR
    : import.meta.env.VITE_APP_API_ROOT_CAPRIKORN;
};

const defaultFetchiosConfig: FetchiosDefaultParams = {
  headers: {
    "x-tenant-id":
      window.tenant === "kuriosity"
        ? localStorage.getItem(LS_KEYS.TENANT) || "kuriosity"
        : window.tenant,
  },
  baseURL: getApiEcmsUrl(),
};

export const apiEcmsHttp = Fetchios.create({
  ...defaultFetchiosConfig,
});

export const unauthenticatedApiEcmsHttp = Fetchios.create({
  ...defaultFetchiosConfig,
});

apiEcmsHttp.interceptors.request.use((config) => {
  const accessToken = localStorage.getItem(LS_KEYS.ACCESS_TOKEN);

  return accessToken
    ? {
        ...config,
        headers: {
          ...config.headers,
          "x-group-reference": GROUP_REFERENCE.current,
          Authorization: `Bearer ${accessToken}`,
        },
      }
    : config;
});

export const fetchiosHttp = Fetchios.create();
